import { cn } from "@/lib/utils";

export default function ResponsivePageHeader({
  eyebrow,
  title,
  description,
  action,
  filters,
  className,
}) {
  return (
    <header className={cn("flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between", className)}>
      <div className="min-w-0">
        {eyebrow && <div className="mono-eyebrow">{eyebrow}</div>}
        <h1 className="font-display text-2xl tracking-tight sm:text-3xl">{title}</h1>
        {description && (
          <p className="mt-1 max-w-prose text-xs leading-5 text-muted-foreground">{description}</p>
        )}
      </div>
      {(action || filters) && (
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center sm:justify-end">
          {filters}
          {action}
        </div>
      )}
    </header>
  );
}
